import React from "react";
import { ErrorMessage } from "formik";
import styles from "./MaxPlayersInput.module.scss";

interface MaxPlayersInputProps {
  name: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  error?: string;
}

export const MaxPlayersInput: React.FC<MaxPlayersInputProps> = ({
  name,
  value,
  onChange,
  onBlur,
  error,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value.replace(/[^0-9]/g, "");
    onChange(newValue);
  };

  return (
    <div className={styles.container}>
      <label className={styles.label} htmlFor={name}>
        Количество игроков
      </label>
      <input
        id={name}
        name={name}
        type="text"
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        placeholder="Введите количество"
        className={`${styles.input} ${error ? styles.inputError : ""}`}
        maxLength={4}
      />
      {error && <div className={styles.errorMessage}>{error}</div>}
    </div>
  );
};
